// removed by extract-text-webpack-plugin
module.exports = {"editNode":"EditNode__editNode___3vWxX","label":"EditNode__label___OgU65","body":"EditNode__body___3SZXX","bodyWrap":"EditNode__bodyWrap___3qUXP"};


//////////////////
// WEBPACK FOOTER
// ./src/components/EditNode/EditNode.scss
// module id = 106
// module chunks = 0